<template>
  <!--
      作者：Lz
      时间：2020-06-09
      描述：会员-等级管理
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="等级管理" name="grade_list"></el-tab-pane>
      <el-tab-pane label="等级设置" name="settings"></el-tab-pane>
    </el-tabs>

    <!--余额明细-->
    <index v-if="activeName === 'grade_list'"></index>
    <!--充值设置-->
    <Setting v-if="activeName === 'settings'"></Setting>
  </div>
</template>
<script>
import Setting from './part/Setting';
import index from './part/index';
export default {
  components: {
    Setting,
    index
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'grade_list'
    };
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/views/user/grade/index.vue